// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210604/js/" + chunkId + "." + {"44":"0ba62723","225":"68c060ad","481":"f5b0744e","486":"3202afd4","770":"90e5b65b"}[chunkId] + ".0.052606775707551456.chunk.js";
};